'use client';

import React, { useState, useEffect, useRef } from 'react';
import dayjs from 'dayjs';

import { RichText } from '@/components/RichText';
import { Media } from '@/components/Media';
import { Rating } from '@ui/rating';
import { cn } from '@/utilities/cn';
import type { Review } from '@/payload-types';

export const CardReview: React.FC<{
  doc: Review;
  className?: string;
}> = ({ doc, className }) => {
  const { authorName, content, rating, platform, createdAt } = doc;
  const [hasMore, setHasMore] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      const contentHeight = contentRef.current.clientHeight;
      setHasMore(contentHeight > 216);
    }
  }, []);

  return (
    <div
      className={cn(
        'corners w-full bg-[#EEEEEE]/60 p-6 py-9 pr-[19px] pl-6 sm:px-4 sm:pt-[30px] md:p-5',
        className,
      )}
    >
      <div className="mb-[25px] flex items-center justify-between gap-3 md:mb-4">
        {platform && typeof platform === 'object' && (
          <Media
            className="max-w-[289px] md:max-w-[150px]"
            resource={platform.logo}
          />
        )}
        <Rating rating={rating!} />
      </div>
      <div
        className="md:!max-h-[210px]"
        style={{
          overflow: showMore ? 'visible' : 'hidden',
          maxHeight: showMore ? 'none' : '216px',
        }}
      >
        <div ref={contentRef}>
          <RichText data={content} />
        </div>
      </div>
      {hasMore && !showMore && (
        <button
          className="text-blue link-secondary md:mt-1"
          onClick={() => setShowMore(true)}
        >
          Показать еще
        </button>
      )}

      <div className="mt-5 flex items-center justify-between">
        <h4 className="h6">{authorName}</h4>
        <div className="text-gray-300">
          {dayjs(createdAt).format('DD.MM.YYYY')}
        </div>
      </div>
    </div>
  );
};
